import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { brandName, checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'gold' | 'outline';
  className?: string;
}
const variants = {
  gold: 'bg-accent text-white hover:bg-accent-hover shadow-lg shadow-accent/20 focus-visible:outline-accent',
  outline: 'border border-accent/50 text-accent hover:border-accent hover:bg-accent-soft focus-visible:outline-accent'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-9 py-5 text-[15px]' : 'px-7 py-4 text-[13px] sm:text-sm';
  const handleClick = () => {
    if (href !== checkoutUrl) return;
    trackPixelEvent('InitiateCheckout', {
      content_name: brandName,
      value: 19,
      currency: 'EUR'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-full font-sans font-bold uppercase tracking-[0.12em] transition-[background-color,border-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-46" data-mp="35xxsmqt5qpta">
      <span data-id="element-47" data-mp="3oviio17nrufh">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.2} aria-hidden="true" data-id="element-48" data-mp="3ou7ei0aawknu" />
    </a>;
}